import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
const variantStyles = {
    primary: css `
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.blue600};
    border-color: ${({ theme }) => theme.colors.blue600};

    &:not(:disabled):hover {
      background: ${({ theme }) => theme.colors.navy900};
      border-color: ${({ theme }) => theme.colors.navy900};
    }
  `,
    secondary: css `
    color: ${({ theme }) => theme.colors.navy900};
    background: ${({ theme }) => theme.colors.mint50};
    border-color: ${({ theme }) => theme.colors.mint200};

    &:not(:disabled):hover {
      border-color: ${({ theme }) => theme.colors.blue600};
      background: ${({ theme }) => theme.colors.white};
    }
  `,
    ghost: css `
    color: ${({ theme }) => theme.colors.navy900};
    background: transparent;
    border-color: transparent;

    &:not(:disabled):hover {
      background: ${({ theme }) => theme.colors.mint50};
    }
  `
};
const buttonBase = css `
  display: inline-flex;
  min-height: 3rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: 0.85rem 1.25rem;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
  transition:
    background 160ms ease,
    border-color 160ms ease,
    color 160ms ease;

  svg {
    flex-shrink: 0;
  }

  ${({ $variant = 'primary' }) => variantStyles[$variant]}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.62;
  }
`;
export const Button = styled.button `
  ${buttonBase}
`;
export const ButtonLink = styled(Link) `
  ${buttonBase}
`;
